module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-card-title', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.siteDialog = true;
        _vm.selectedKey = null;
        _vm.selectedCustomer = {
          id: null
        }
      }
    }
  }, [_vm._v("Add Site")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Only Head Offices",
      "color": "primary",
      "hide-details": ""
    },
    model: {
      value: (_vm.onlyHeadOffice),
      callback: function($$v) {
        _vm.onlyHeadOffice = $$v
      },
      expression: "onlyHeadOffice"
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.filteredSites,
      "search": _vm.search,
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.selectedKey = props.item.key;
              _vm.siteDialog = true;
              _vm.selectedCustomer = {
                id: props.item.Customer
              }
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.customerName)), (props.item.headOffice) ? _c('v-chip', {
          attrs: {
            "small": "",
            "color": "red",
            "text-color": "white"
          }
        }, [_vm._v(_vm._s('Head Office'))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.Town))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.PostCode))]), _vm._v(" "), _c('td', [_c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.deleteSite(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("delete")])], 1)], 1)])]
      }
    }])
  })], 1), _vm._v(" "), _c('site-edit-dialog', {
    attrs: {
      "customer": _vm.selectedCustomer,
      "customers": _vm.customers,
      "siteDialog": _vm.siteDialog,
      "siteID": _vm.selectedKey
    },
    on: {
      "getSites": _vm.getSites,
      "setCustomer": _vm.updateCustomer,
      "update:siteDialog": function($event) {
        _vm.siteDialog = $event
      },
      "update:site-dialog": function($event) {
        _vm.siteDialog = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8587302","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sites.vue
// module id = 771
// module chunks = 1